<div class="flow-select" [style.width.px]="width">
  @if (title) {
    <label agText="body-3-medium" class="select-title">{{ title }}</label>
  }

  <div class="select-anchor">
    <button #trigger class="select-button" [class.disabled]="disabled" [class.has-selection]="hasSelection" [class.error]="error" [class.open]="open" [class.leading]="iconPosition === 'leading'" [disabled]="disabled" (click)="toggle()">
      @if (iconPosition === "leading") {
        <img class="chevron" [class.open]="open" [src]="iconService.Icon.expand" />
      }
      <span agText="body-3" style="cursor: pointer" class="select-label" [class.placeholder]="!hasSelection">{{ displayLabel }}</span>
      @if (iconPosition === "trailing") {
        <img class="chevron" [class.open]="open" [src]="iconService.Icon.expand" />
      }
    </button>

    <flow-drop-down
      [type]="type"
      [searchbarLabel]="searchbarLabel"
      [footer]="footer"
      [dividers]="dividers"
      [items]="items"
      [addable]="addable"
      [addPlaceholder]="addPlaceholder"
      [addTriggerLabel]="addTriggerLabel"
      [addedCheckbox]="addedCheckbox"
      [emptyTitle]="emptyTitle"
      [emptySubtitle]="emptySubtitle"
      [noResultsTitle]="noResultsTitle"
      [noResultsSubtitle]="noResultsSubtitle"
      [width]="dropdownWidth"
      [height]="height"
      [open]="open"
      [foldUp]="foldUp"
      [alignRight]="alignRight"
      [triggerElement]="trigger"
      (openChange)="onOpenChange($event)"
      (itemSelected)="onItemSelected($event)"
      (itemsChange)="onItemsChange($event)"
      (itemAdded)="onItemAdded($event)"
      (itemRemoved)="onItemRemoved($event)"
      (footerPrimaryAction)="onFooter('primary')"
      (footerSecondaryAction)="onFooter('secondary')"
      (footerTertiaryAction)="onFooter('tertiary')"></flow-drop-down>
  </div>

  @if (helperText) {
    <flow-helper-text [helperText]="helperText" [showIcon]="helperIcon" [variant]="error ? 'destructive' : 'default'"></flow-helper-text>
  }
</div>
